import script from "./StatusPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatusPop.vue?vue&type=script&setup=true&lang=ts"

import "./StatusPop.vue?vue&type=style&index=0&id=5adfa5fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adfa5fe"]])

export default __exports__